import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../Pages/hooks/useAuth";

export default function ProtectedUserRoute({ children }) {
  const { auth } = useAuth();
  const location = useLocation();

  // If not authenticated, redirect to login with the current location
  if (!auth?.accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // While loading user data, show nothing (avoid layout flash)
  if (auth?.accessToken && !auth?.user) {
    return null;
  }

  // If authenticated, allow access
  return children;
}
